export const actions = {
  DIAS_ESPECIALES_LOAD_REQUESTED: 'DIAS_ESPECIALES_LOAD_REQUESTED',
  DIAS_ESPECIALES_LOAD_SUCCEEDED: 'DIAS_ESPECIALES_LOAD_SUCCEEDED',
  DIAS_ESPECIALES_LOAD_FILED: 'DIAS_ESPECIALES_LOAD_FILED',

  DIAS_ESPECIALES_EDITAR_LOAD_REQUESTED: 'DIAS_ESPECIALES_EDITAR_LOAD_REQUESTED',
  DIAS_ESPECIALES_EDITAR_LOAD_SUCCEEDED: 'DIAS_ESPECIALES_EDITAR_LOAD_SUCCEEDED',
  DIAS_ESPECIALES_EDITAR_LOAD_FILED: 'DIAS_ESPECIALES_EDITAR_LOAD_FILED',

  DIA_ESPECIAL_INSERT_REQUESTED: 'DIA_ESPECIAL_INSERT_REQUESTED',
  DIA_ESPECIAL_INSERT_SUCCEEDED: 'DIA_ESPECIAL_INSERT_SUCCEEDED',
  DIA_ESPECIAL_INSERT_FILED: 'DIA_ESPECIAL_INSERT_FILED',

  DIA_ESPECIAL_UPDATE_REQUESTED: 'DIA_ESPECIAL_UPDATE_REQUESTED',
  DIA_ESPECIAL_UPDATE_SUCCEEDED: 'DIA_ESPECIAL_UPDATE_SUCCEEDED',
  DIA_ESPECIAL_UPDATE_FILED: 'DIA_ESPECIAL_UPDATE_FILED',

  DIA_ESPECIAL_EDITAR_UPDATE_REQUESTED: 'DIA_ESPECIAL_EDITAR_UPDATE_REQUESTED',
  DIA_ESPECIAL_EDITAR_UPDATE_SUCCEEDED: 'DIA_ESPECIAL_EDITAR_UPDATE_SUCCEEDED',
  DIA_ESPECIAL_EDITAR_UPDATE_FILED: 'DIA_ESPECIAL_EDITAR_UPDATE_FILED',

  DIA_ESPECIAL_DELETE_REQUESTED: 'DIA_ESPECIAL_DELETE_REQUESTED',
  DIA_ESPECIAL_DELETE_SUCCEEDED: 'DIA_ESPECIAL_DELETE_SUCCEEDED',
  DIA_ESPECIAL_DELETE_FILED: 'DIA_ESPECIAL_DELETE_FILED',

  DIA_ESPECIAL_EDITAR_DELETE_REQUESTED: 'DIA_ESPECIAL_EDITAR_DELETE_REQUESTED',
  DIA_ESPECIAL_EDITAR_DELETE_SUCCEEDED: 'DIA_ESPECIAL_EDITAR_DELETE_SUCCEEDED',
  DIA_ESPECIAL_EDITAR_DELETE_FILED: 'DIA_ESPECIAL_EDITAR_DELETE_FILED',

  DIA_ESPECIAL_EDITAR_INSERT_REQUESTED: 'DIA_ESPECIAL_EDITAR_INSERT_REQUESTED',
  DIA_ESPECIAL_EDITAR_INSERT_SUCCEEDED: 'DIA_ESPECIAL_EDITAR_INSERT_SUCCEEDED',
  DIA_ESPECIAL_EDITAR_INSERT_FILED: 'DIA_ESPECIAL_EDITAR_INSERT_FILED',

  DIA_ESPECIAL_BY_ID_LOAD_REQUESTED: 'DIA_ESPECIAL_BY_ID_LOAD_REQUESTED',
  DIA_ESPECIAL_BY_ID_LOAD_SUCCEEDED: 'DIA_ESPECIAL_BY_ID_LOAD_SUCCEEDED',
  DIA_ESPECIAL_BY_ID_LOAD_FILED: 'DIA_ESPECIAL_BY_ID_LOAD_FILED',
}

export const getDiasEspecialesAction = dispatch => {
  dispatch({
    type: actions.DIAS_ESPECIALES_LOAD_REQUESTED,
  })
}

export const onSubmitDiaEspecialAction = (dispatch, diaEspecialForm) => {
  dispatch({
    type: actions.DIA_ESPECIAL_INSERT_REQUESTED,
    payload: diaEspecialForm,
  })
}

export const onSubmitDiaEspecialUpdateAction = (dispatch, diaEspecialForm) => {
  dispatch({
    type: actions.DIA_ESPECIAL_UPDATE_REQUESTED,
    payload: diaEspecialForm,
  })
}

export const deleteDiaEspecialAction = (dispatch, id) => {
  dispatch({
    type: actions.DIA_ESPECIAL_DELETE_REQUESTED,
    payload: id,
  })
}

export const getDiasEspecialesEditarAction = (dispatch, diaEspecialId) => {
  dispatch({
    type: actions.DIAS_ESPECIALES_EDITAR_LOAD_REQUESTED,
    payload: diaEspecialId,
  })
}

export const onSubmitDiaEspecialEditarUpdateAction = (dispatch, diaEspecialForm) => {
  dispatch({
    type: actions.DIA_ESPECIAL_EDITAR_UPDATE_REQUESTED,
    payload: diaEspecialForm,
  })
}

export const deleteDiaEspecialEditarAction = (dispatch, disabledEnabledForm) => {
  dispatch({
    type: actions.DIA_ESPECIAL_EDITAR_DELETE_REQUESTED,
    payload: disabledEnabledForm,
  })
}

export const onSubmitDiaEspecialEditarAction = (dispatch, horarioEntregaForm) => {
  dispatch({
    type: actions.DIA_ESPECIAL_EDITAR_INSERT_REQUESTED,
    payload: horarioEntregaForm,
  })
}

export const getDiaEspecialAction = (dispatch, id) => {
  dispatch({
    type: actions.DIA_ESPECIAL_BY_ID_LOAD_REQUESTED,
    payload: id,
  })
}
